(function () {

    'use strict';
    angular.module('app')
        .controller('dashboardController', ['$scope', '$location', '$routeParams', '$uibModal', 'dashboardService', '_', 'accountsService', dashboardController]
        );

    function dashboardController($scope, $location, $routeParams, $uibModal, dashboardService, _, accountsService) {
        $scope.model = {};
        $scope.model.Loading = false;
        $scope.model.showError = false;
        $scope.model.Working = false;
        $scope.model.DidYouKnow = '';
        $scope.model.DidYouKnowMessages = [
            '<span class="gator_apps_app_text_left dark">Gator</span><span class="GatorExpress brand">Express</span> and <span class="gator_apps_app_text_left dark">Gator</span><span class="GatorWorkflow brand">Workflow</span> use the exact same credentials as <span class="gator_apps_app_text_left dark">Gator</span><span class="GatorMail brand">Mail</span>? feel free to add your <span class="gator_apps_app_text_left dark">Gator</span><span class="GatorMail brand">Mail</span> account for each of these...',
            'You should only link your own accounts.  Linking shared or another persons account could cause problems with passwords changing.',
            'To get your <span class="gator_apps_app_text_left dark">Gator</span><span class="GatorSocial brand">Social</span> credentials. Log in to <span class="gator_apps_app_text_left dark">Gator</span><span class="GatorSocial brand">Social</span> from <span class="gator_apps_app_text_left dark">Gator</span><span class="GatorMail brand">Mail</span> and you will be able to create your own account to link in <span class="gator_apps_app_text_left dark">Gator</span><span class="GatorSignOn brand">SignOn</span>.',
            'The <span class="gator_apps_app_text_left dark">Gator</span><span class="GatorSignOn brand">SignOn</span> menu will follow you everywhere until you sign out of <span class="gator_apps_app_text_left dark">Gator</span><span class="GatorSignOn brand">SignOn</span>.  This forces logout of all linked accounts,  then you can navigate and log into any product urls like normal.',
            'You can double click the icons on the dashboard to Default, Rename or Remove an account from <span class="gator_apps_app_text_left dark">Gator</span><span class="GatorSignOn brand">SignOn</span>.',
            'The 3 person icon, that appears on right of the <span class="gator_apps_app_text_left dark">Gator</span><span class="GatorSignOn brand">SignOn</span> bar, will bring you back to this dashboard.',
            'You can make your account even more secure by enabling 2-Factor Google authentication under your account settings.'
        ];



        $scope.AttachMultipleAccounts = function () {
            $scope.model.SuccessMultiAccounts.forEach(function (account) {
                if (account.Selected) {

                    var message = JSON.parse(account.Message);
                    var attachResponse = dashboardService
                        .attachAccount(account
                            .ClientId,
                        message.UniqueId,
                        message.DisplayName,
                        account.loginId);

                    // add multiple accounts
                    attachResponse.then(function (result) {
                        $('#multiAccountModal').modal('hide');
                        $scope.loadClientUsers();
                        location.href = location.href;
                    });


                }
            });

        };
        $scope.SelectItem = function (sender, account) {

            account.Selected = !account.Selected;
            return false;
            //var allVal = new Array();
            //$('.llstMulti li.active').each(function () {
            //    allVal.push($(this).attr('opt'));
            //});

            //$('#myselect').val(allVal);

        };
        $scope.NavigateClientRedirectUrl = function (client, linkId) {

            if (!$scope.model.Working) {
                $scope.model.Working = true;
                dashboardService.GetClientRedirectUrl(client.id, linkId)
                    .then(function (response) {

                            $scope.storeLogin(client);
                        // success
                        window.location = response;
                    },
                    function (response) {
                        $scope.model.Working = false;
                        // error
                        // alert(response.error);
                    });
            }
        };
        var getCookie = function (cname) {
            var name = cname + '=';
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';
        };
        var getLogin = function () {
            var obj = getCookie('SsoLoggedIn');

            if (obj != null && obj.length > 0)
                return obj;
            else
                return '';
        };
        var setCookie = function (cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            var expires = 'expires=' + d.toUTCString();
            document.cookie = cname + '=' + cvalue + ';' + expires + ';domain=' + '.communigator.co.uk' + ';path=/';
        };
        var checkAndGenerateArray = function (array, clientId) {
            if (array == null)
                array = [];

            if (array.length < clientId)
                for (var i = array.length; i <= clientId; i++)
                    array.push({}); 

            return array;
        };

        $scope.storeLogin = function (clientAccount) {

            $scope.model.currentClientUserArray = getLogin();
            setCookie('SsoLoggedIn', JSON.stringify($scope.model.currentClientUserArray), 7);
        };

      

        $scope.removeClientUser = function (clientId, collection, itemIndex, emailAddress) {
            if (!$scope.model.Working) {
                $scope.model.Working = true;

                if (clientId === 3) {
                    $scope.model.Working = false;
                    // GatorLeads
                    $scope.removeClientUsers(collection, emailAddress);
                    return;
                }

                var accountToRemove = collection[itemIndex];

                dashboardService.removeClientUser(accountToRemove.id)
                    .then(function () {
                        $scope.model.Working = false;
                        collection.splice(itemIndex, 1);

                        //$scope.loadClientUsers();
                        location.href = location.href;
                    },
                    function (response) {
                        $scope.model.Working = false;
                        // error
                        // alert(response.error);
                    });
            }
        };

        $scope.removeClientUsers = function (collection, emailAddress) {

            // Make sure the array is empty
            var accountsForRemoval = [];


            collection.forEach(function (account) {
                if (account.emailAddress === emailAddress) {
                    accountsForRemoval.push(account);
                }
            });

            $scope.detachAccountsModal(accountsForRemoval);

        };


        $scope.defaultClientUser = function (accounts, item) {

            accounts.forEach(function (account) {
                account.isDefault = false;
            });
            item.isDefault = true;

        };

        $scope.update = function (accounts) {


            dashboardService.updateClientAccounts(accounts)
                .then(function () {
                    //$scope.loadClientUsers();
                    location.href = location.href;
                },
                function (response) {
                    // error
                    // alert(response.error);
                });

        };
        $scope.attachAccountModal = function (client) {
            var modalInstance = $uibModal.open({
                templateUrl: './assets/templates/modals/attach_account.html',
                controller: 'attachAccountController',
                size: 'md',
                resolve: {
                    clientToAttach: function () {
                        return client;
                    }
                }
            });

            modalInstance.result.then(function (response) {
                if (response)
                    $scope.loadClientUsers();
            });
        };

        $scope.detachAccountsModal = function (accountsForRemoval) {
            var modalInstance = $uibModal.open({
                templateUrl: './assets/templates/modals/detach_accounts.html',
                controller: 'detachAccountsController',
                size: 'sm',
                resolve: {
                    clientsToDetach: function () {
                        return accountsForRemoval;
                    },
                    collection: function () {
                        return $scope.model.GatorLeadsAccounts;
                    }
                }
            });

            modalInstance.result.then(function (response, newArray) {

                if (response.success)
                    $scope.loadClientUsers();
            });
        };

        $scope.getTemplate = function (product) {
            return 'Assets/Templates/SignUp/' + product + '.html';
        }

        $scope.loadClients = function () {


            dashboardService.GetClients()
                .then(function (response) {
                    $scope.model.Clients = [];
                    $scope.model.GatorApps = [];
                    $scope.model.GatorClients = [];

                    response.forEach(function (client) {

                        if (!client.isHidden) {
                            if (client.clientDetails.length > 0) {
                                client.attachClientDetailsId = client.clientDetails[0].id;
                                client.attachUsername = '';
                                client.attachPassword = '';
                            }

                            if (client.id === gatorClients.Express) {
                                client.ClientAccounts = $scope.model.GatorExpressAccounts;

                            } else if (client.id === gatorClients.Mail) {
                                client.ClientAccounts = $scope.model.GatorMailAccounts;

                            } else if (client.id === gatorClients.Social) {
                                client.ClientAccounts = $scope.model.GatorSocialAccounts;

                            } else if (client.id === gatorClients.Leads) {
                                client.ClientAccounts = $scope.model.GatorLeadsAccounts;

                            } else if (client.id === gatorClients.Workflow) {
                                client.ClientAccounts = $scope.model.GatorWorkflowAccounts;

                            } else if (client.id === gatorClients.Docs) {
                                client.ClientAccounts = $scope.model.GatorDocsAccounts;
                            }
                            else if (client.id === gatorClients.Survey) {
                                client.ClientAccounts = $scope.model.GatorSurveyAccounts;
                            }
                            else if (client.id === gatorClients.SendForensics) {
                                client.ClientAccounts = $scope.model.GatorForensicsAccounts;
                            }
                            else if (client.id === gatorClients.SEO) {
                                client.ClientAccounts = $scope.model.GatorSEOAccounts;
                            }
                            else if (client.id === gatorClients.Popup) {
                                client.ClientAccounts = $scope.model.GatorPopupAccounts;
                            }
                            else if (client.id === gatorClients.Report) {
                                client.ClientAccounts = $scope.model.GatorReportAccounts;
                            }


                            if (client.id !== gatorClients.SignOn) {
                                $scope.model.Clients.push(client);
                                if (client.isThirdParty) {
                                    $scope.model.GatorApps.push(client);
                                } else {
                                    $scope.model.GatorClients.push(client);
                                }
                            }
                        }
                    });

                });
        };

        $scope.loadClientUsers = function () {
            accountsService.getAuthorizedAccount()
                .then(function (response) {
                    $scope.model.account = response;
                    $scope.model.GatorExpressAccounts = [];
                    $scope.model.GatorMailAccounts = [];
                    $scope.model.GatorSocialAccounts = [];
                    $scope.model.GatorLeadsAccounts = [];
                    $scope.model.GatorWorkflowAccounts = [];
                    $scope.model.GatorDocsAccounts = [];
                    $scope.model.GatorCreatorAccounts = [];
                    $scope.model.GatorSurveyAccounts = [];
                    $scope.model.GatorForensicsAccounts = [];
                    $scope.model.GatorSEOAccounts = [];
                    $scope.model.GatorPopupAccounts = [];
                    $scope.model.GatorReportAccounts = [];

                    $scope.model.showError = $location.search()['warn'] === 'true';

                    var clientUsers = response.ssoClientUsers;

                    if (clientUsers) {
                        for (var i = 0; i < clientUsers.length; i++) {
                            var linkedAccount = clientUsers[i];

                            if (linkedAccount.ssoClientId === gatorClients.Express) {
                                $scope.model.GatorExpressAccounts.push(linkedAccount);
                            } else if (linkedAccount.ssoClientId === gatorClients.Mail) {
                                $scope.model.GatorMailAccounts.push(linkedAccount);
                            } else if (linkedAccount.ssoClientId === gatorClients.Social) {
                                $scope.model.GatorSocialAccounts.push(linkedAccount);
                            } else if (linkedAccount.ssoClientId === gatorClients.Leads) {
                                $scope.model.GatorLeadsAccounts.push(linkedAccount);
                            } else if (linkedAccount.ssoClientId === gatorClients.Workflow) {
                                $scope.model.GatorWorkflowAccounts.push(linkedAccount);
                            } else if (linkedAccount.ssoClientId === gatorClients.Docs) {
                                $scope.model.GatorDocsAccounts.push(linkedAccount);
                            } else if (linkedAccount.ssoClientId === gatorClients.Survey) {
                                $scope.model.GatorSurveyAccounts.push(linkedAccount);
                            } else if (linkedAccount.ssoClientId === gatorClients.SendForensics) {
                                $scope.model.GatorForensicsAccounts.push(linkedAccount);
                            } else if (linkedAccount.ssoClientId === gatorClients.SEO) {
                                $scope.model.GatorSEOAccounts.push(linkedAccount);
                            } else if (linkedAccount.ssoClientId === gatorClients.Popup) {
                                $scope.model.GatorPopupAccounts.push(linkedAccount);
                            } else if (linkedAccount.ssoClientId === gatorClients.Report) {
                                $scope.model.GatorReportAccounts.push(linkedAccount);
                            }
                        }
                        $scope.loadClients();
                    }
                    $scope.model.waiting = false;
                });
        };

        $scope.loadClientUsers();

        $scope.canAddAccount = function (client) {

            if (!client.isUserAddable) {
                return false;
            }

            if (client.type === 14) {
                return false;
            }


            var clientsAllowed = [];

            angular.forEach(client.clientDetails,
                function (details) {
                    var endPointsEnum = details.availableEndPoints;

                    if (details.apiUrl !== null &&
                        ((endPointsEnum & ssoEndPoints.CreateAccount) === ssoEndPoints.CreateAccount) ||
                        ((endPointsEnum & ssoEndPoints.AttachClientUser) === ssoEndPoints.AttachClientUser) ||
                        ((endPointsEnum & ssoEndPoints.AttachClientUsers) === ssoEndPoints.AttachClientUsers)
                    ) {
                        clientsAllowed.push(details);
                    };
                },
                clientsAllowed);

            return clientsAllowed.length > 0;

        };

    }
})();